import useSWR from "swr";
import {
  buildTrackingKey,
  fetchTrackingContents,
} from "../services/trackingContents";
import { ProgressNode } from "../types";
import { getTrackingKind } from "../utils";

export const useTrackingContents = (
  corporateId: string | number | undefined,
  userId: string | number | undefined,
  node: ProgressNode | null,
) => {
  const kind = node ? getTrackingKind(node) : null;
  const request =
    node && kind && corporateId !== undefined && userId !== undefined
      ? { corporateId, userId, node }
      : null;

  const { data, error, isLoading, mutate } = useSWR(
    request && kind ? buildTrackingKey(kind, request) : null,
    () => (request && kind ? fetchTrackingContents(kind, request) : []),
    { onError: () => null, revalidateOnMount: true },
  );

  return { contents: data ?? [], isLoading, hasError: !!error, mutate };
};
